// extracted by css-extract-rspack-plugin
export default {"clientNotesContainer":"clientNotesContainer-en7YWP","sectionTitle":"sectionTitle-mBbSFW","notes":"notes-JRcjJh"};